import { render, staticRenderFns } from "./personalCenter.vue?vue&type=template&id=211ab461&scoped=true&"
import script from "./personalCenter.vue?vue&type=script&lang=ts&"
export * from "./personalCenter.vue?vue&type=script&lang=ts&"
import style0 from "./personalCenter.vue?vue&type=style&index=0&id=211ab461&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "211ab461",
  null
  
)

export default component.exports